import { useSearchParams } from 'next/navigation'

import { HOLIDAYS_APP_PARAM } from '@/src/utils/holidays'

/**
 * Whether the page is open inside the native app's WebView (`?isApp=true`). Read from the URL, so
 * it is known during SSR and the site header never renders there.
 */
export const useHolidayAppMode = () => useSearchParams().get(HOLIDAYS_APP_PARAM) === 'true'

export default useHolidayAppMode
